import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import {
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  getFancyOddForEntity,
  setBet,
} from "./CasinoGeneric";
import { useLocation } from "react-router-dom";
import PlaceBet from "./components/PlaceBet";
import CasinoVideo from "./components/CasinoVideo";
import PlacedBet from "./components/PlacedBet";
import Timer from "./components/Timer";
import CasinoPage from "./components/CasinoPage";
export default function Trap() {
  // const GAME_ID = "Trap";
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  const VIDEO_ID = 3056;
  const dispatch = useDispatch();
  const CARD_MAPPING = {
    S: 1,
    H: 2,
    D: 3,
    C: 4,
  };
  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );
  const lastTenResultData = useQuery(
    "getResult",
    () => getCasinoLastTenResultAPI(GAME_ID),
    {
      refetchInterval: 1500,
    }
  );
  const casinoBets = useQuery("casinoBets", () => getCasinoBetsAPI(GAME_ID), {
    refetchInterval: 2500,
  });
  const [selectedTab, setSelectedTab] = React.useState("game");
  const isMobile = window.innerWidth < 768;
  const [casinoPlData, setCasinoPlData] = useState([]);
  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      // VIDEO_ID={CASINO_VIDEO.teenPatti1Day}
      VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      shortName={"trap"}
      gameName={"trap"}
    >
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-table-left-box">
              <div className="casino-table-body">
                <div className="casino-table-row ">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">Player A</div>
                    <div className="casino-nation-book text-success" />
                  </div>
                  <div
                    className={`casino-odds-box back ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player A", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player A", casinoData, true)}{" "}
                    </span>
                  </div>
                  <div
                    className={`casino-odds-box lay  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player A", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player A", casinoData, false)}{" "}
                    </span>
                  </div>
                  {/* <div className="casino-nation-book text-center w-100" /> */}
                  <div className="casino-nation-book d-none d-md-block w-100">
                    {getCasinoPlExposureByRunner(casinoPlData, "Player A")}
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-table-box-divider" />
            <div className="casino-table-right-box">
              <div className="casino-table-body">
                <div className="casino-table-row ">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">Player B</div>
                    <div className="casino-nation-book text-success" />
                  </div>
                  <div
                    className={`casino-odds-box back ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player B", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player B", casinoData, true)}{" "}
                    </span>
                  </div>
                  <div
                    className={`casino-odds-box lay  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player B", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player B", casinoData, false)}{" "}
                    </span>
                  </div>
                  <div className="casino-nation-book d-none d-md-block w-100">
                    {getCasinoPlExposureByRunner(casinoPlData, "Player B")}
                  </div>
                  {/* <div className="casino-nation-book text-center w-100" /> */}
                  {/* <div className="casino-nation-book ">
                          {getCasinoPlExposureByRunner(casinoPlData, "Player B")}{" "}
                        </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="casino-table-box mt-3 sevenupbox">
            <div className="casino-table-left-box">
              <h4 className="d-md-none mb-2">Player</h4>
              <div className="seven-up-down-box">
                <div className="up-box">
                  <div className="up-down-book" />
                  <div className="text-end">
                    {/* <div className="up-down-odds">2</div> */}
                    <div className="up-down-odds">
                      <span className="casino-odds">
                        {" "}
                        {getFancyOddForEntity(
                          casinoData?.data?.response?.fancyOddDetailsDTOS?.[1]
                            ?.runnerName,
                          casinoData,
                          true
                        )}
                      </span>
                    </div>
                    <span>Low</span>
                  </div>
                </div>
                <div className="down-box">
                  <div className="up-down-book" />
                  <div className="text-start">
                    <div className="up-down-odds">
                      <span className="casino-odds">
                        {" "}
                        {getFancyOddForEntity(
                          casinoData?.data?.response?.fancyOddDetailsDTOS?.[0]
                            ?.runnerName,
                          casinoData,
                          true
                        )}
                      </span>
                    </div>
                    <span>High</span>
                  </div>
                </div>
                <div className="seven-box">
                  <img src="https://g1ver.sprintstaticdata.com/v53/static/front/img/trape-seven.png" />
                </div>
              </div>
            </div>
            <div className="casino-table-box-divider" />
            <div className="casino-table-right-box">
              <div className="casino-table-body">
                <div className="casino-table-row ">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      <img src="https://g1ver.sprintstaticdata.com/v53/static/front/img/cards/J.png" />
                      <img src="https://g1ver.sprintstaticdata.com/v53/static/front/img/cards/Q.png" />
                      <img src="https://g1ver.sprintstaticdata.com/v53/static/front/img/cards/K.png" />
                    </div>
                    <div className="casino-nation-book " />
                  </div>
                  {/* <div className="casino-odds-box back">
                          <span className="casino-odds">4.17</span>
                        </div>
                        <div className="casino-odds-box lay">
                          <span className="casino-odds">4.5</span>
                        </div> */}

                  <div
                    className={`casino-odds-box back ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.fancy2OddDetailsDTOS?.[2]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getFancyOddForEntity(
                        casinoData?.data?.response?.fancyOddDetailsDTOS?.[2]
                          ?.runnerName,
                        casinoData,
                        true
                      )}
                    </span>
                  </div>
                  <div
                    className={`casino-odds-box lay  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.fancy2OddDetailsDTOS?.[2]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "false"
                      )
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getFancyOddForEntity(
                        casinoData?.data?.response?.fancyOddDetailsDTOS?.[2]
                          ?.runnerName,
                        casinoData,
                        false
                      )}
                    </span>
                  </div>
                  <div className="casino-nation-book ">
                    {getCasinoPlExposureByRunner(
                      casinoPlData,
                      "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[2]?.runnerName"
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="casino-remark mt-3">
            <marquee scrollamount={3}>
              IT'S EITHER PLAYER A OR B, WHO SCORES A TOTAL OF 13,14,15 WILL
              FALL INTO THE TRAP &amp; LOSE THE GAME. AVOID FALLING INTO THE
              TRAP &amp; WIN REAL MONEY.
            </marquee>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
                <span>Last Result</span>
                <span>
                  <a href="/casinoresults">View All</a>
                </span>
              </div> */}
        {/* <div className="casino-last-results">
                <span className="result result-b">B</span>
                <span className="result result-a">A</span>
                <span className="result result-b">B</span>
                <span className="result result-a">A</span>
                <span className="result result-a">A</span>
                <span className="result result-a">A</span>
                <span className="result result-a">A</span>
                <span className="result result-b">B</span>
                <span className="result result-a">A</span>
                <span className="result result-a">A</span>
              </div> */}
        {/* <div className="trap-number-icon d-xl-none">
                <img src="https://g1ver.sprintstaticdata.com/v53/static/front/img/trap13.png" />
                <img src="https://g1ver.sprintstaticdata.com/v53/static/front/img/trap14.png" />
                <img src="https://g1ver.sprintstaticdata.com/v53/static/front/img/trap15.png" />
              </div> */}
      </div>
    </CasinoPage>
  );
}
